export class ScoresByQuarter {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.name = "ScoreQBQ";
    this.scene = "ScoreQBQ";
    this.data = [];
    this.page = 10006;
  }

  async preview({ options }) {
    this.onAir = false;
    this.options = options;
    let xml = await this.getVizPage({ page: this.page });

    xml.payload.field.find((item) => {
      return item.attr.name === "100"; // Number
    }).value = options.game?.home_team?.variables?.badge || "";

    xml.payload.field.find((item) => {
      return item.attr.name === "106"; // Number
    }).value = options.game?.away_team?.variables?.badge || "";
    if (options.game?.competition?.number_of_periods === 2) {
      xml.payload.field.find((item) => {
        return item.attr.name === "200"; // Number
      }).value = options.game?.scores_by_quarter?.home?.first;
      xml.payload.field.find((item) => {
        return item.attr.name === "202"; // Number
      }).value = options.game?.scores_by_quarter?.away?.first;
      xml.payload.field.find((item) => {
        return item.attr.name === "300"; // Number
      }).value = options.game?.scores_by_quarter?.home?.second;
      xml.payload.field.find((item) => {
        return item.attr.name === "302"; // Number
      }).value = options.game?.scores_by_quarter?.away?.second;
      xml.payload.field.find((item) => {
        return item.attr.name === "400"; // Number
      }).value = options.game?.scores_by_quarter?.home?.goals;
      xml.payload.field.find((item) => {
        return item.attr.name === "402"; // Number
      }).value = options.game?.scores_by_quarter?.away?.goals;
    } else {
      xml.payload.field.find((item) => {
        return item.attr.name === "200"; // Number
      }).value = options.game?.scores_by_quarter?.home?.first;
      xml.payload.field.find((item) => {
        return item.attr.name === "202"; // Number
      }).value = options.game?.scores_by_quarter?.away?.first;
      xml.payload.field.find((item) => {
        return item.attr.name === "300"; // Number
      }).value = options.game?.scores_by_quarter?.home?.second;
      xml.payload.field.find((item) => {
        return item.attr.name === "302"; // Number
      }).value = options.game?.scores_by_quarter?.away?.second;
      xml.payload.field.find((item) => {
        return item.attr.name === "400"; // Number
      }).value = options.game?.scores_by_quarter?.home?.third;
      xml.payload.field.find((item) => {
        return item.attr.name === "402"; // Number
      }).value = options.game?.scores_by_quarter?.away?.third;
      xml.payload.field.find((item) => {
        return item.attr.name === "500"; // Number
      }).value = options.game?.scores_by_quarter?.home?.fourth;
      xml.payload.field.find((item) => {
        return item.attr.name === "502"; // Number
      }).value = options.game?.scores_by_quarter?.away?.fourth;
      xml.payload.field.find((item) => {
        return item.attr.name === "600"; // Number
      }).value = options.game?.scores_by_quarter?.home?.goals;
      xml.payload.field.find((item) => {
        return item.attr.name === "602"; // Number
      }).value = options.game?.scores_by_quarter?.away?.goals;
    }

    await this.updateVizPage({ page: this.page, data: xml });
    this.sendPreview("page:read " + this.page);
  }

  animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    clearTimeout(this.to);
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }
}
